var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.444 2H2.556C1.696 2 1 2.647 1 3.444v10.112C1 14.353 1.696 15 2.556 15h10.888c.86 0 1.556-.647 1.556-1.444V3.444C15 2.647 14.304 2 13.444 2M11 1v2M5 1v2M1 6.5h14"
  })));
};
export { SvgCalendar as ReactComponent };
export default __webpack_public_path__ + "7b0645f1e8d09840c7217da3113dbbb6.svg";